import { pname } from "@/lib/format";
import { r2 } from "@/components/InvoiceItemsEditor";

export const todayLocal = () => new Date().toLocaleDateString("sv-SE");

// "4.999,69" / "4999,69" / "4999.69" → 4999.69
export const parseAmount = (v) => {
  const raw = String(v ?? "").trim();
  const n = parseFloat(raw.includes(",") ? raw.replace(/\./g, "").replace(",", ".") : raw);
  return Number.isFinite(n) ? n : 0;
};

// Fatura kalem adına marka / koda ürün kodu yalnız seçilirse eklenir (varsayılan kapalı)
// Sepet satırı adı markayı zaten içerir (pname) → marka kapalıyken baştaki marka kaldırılır
const trLo = (s) => String(s || "").toLocaleLowerCase("tr");
const stripBrand = (name, brand) => {
  const n = String(name || "").trim(), b = String(brand || "").trim();
  return b && trLo(n).startsWith(`${trLo(b)} `) ? n.slice(b.length).trim() : n;
};
const autoName = (l, brand) => (brand ? pname(l) : stripBrand(l.name, l.brand) || pname(l));
const autoCode = (l, code) => (code ? String(l.code || "") : "");
// Elle değiştirilmiş ad / kod korunur; değiştirilmemişse seçime göre yeniden üretilir
const label = (l, old, labels) => {
  const an = autoName(l, labels.brand), ac = autoCode(l, labels.code);
  return {
    name: old && old.name !== old.auto_name ? old.name : an, auto_name: an,
    code: old && old.code !== old.auto_code ? old.code : ac, auto_code: ac,
  };
};
export const relabel = (lines, cart, labels) => lines.map((x) => {
  const l = x.key === "single" ? null : (cart || []).find((c) => String(c.product_id || "") === x.key);
  return l ? { ...x, ...label(l, x, labels) } : x;
});

// Sepet satırı → fatura kalemi. reflect: liste fiyatı + satır iskontosu (tutarlıysa); değilse KDV hariç net birim fiyat.
// prev: düzenlenmiş kalemler (ad / kod / birim korunur) · labels: { brand, code } marka adı / ürün kodu eklensin mi
export const buildInvoiceLines = (cart, unitNet, reflect, prev = [], labels = {}) => (cart || [])
  .filter((l) => (Number(l.quantity) || 0) > 0)
  .map((l) => {
    const pid = String(l.product_id || "");
    const un = unitNet(l);
    const lp = Number(l.list_price) || 0;
    const d = Number(l.sale_discount) || 0;
    const withDisc = reflect && lp > 0 && d > 0 && Math.abs(lp * (1 - d / 100) - un) <= 0.011;
    const old = prev.find((p) => p.key === pid);
    return {
      key: pid, product_id: pid.startsWith("n:") ? "" : pid, brand: l.brand || "",
      ...label(l, old, labels), unit: old ? old.unit : (l.unit || "ADET"),
      quantity: Number(l.quantity) || 0, unit_price: withDisc ? lp : un, discount_rate: withDisc ? d : 0,
    };
  });

// Tek kalem fatura: tüm sepet tek satır "ELEKTRİK MALZEMESİ" (1 ADET), tutar = anlaşılan sepet tutarı (KDV hariç birim fiyat)
export const SINGLE_NAME = "ELEKTRİK MALZEMESİ";
export const singleLine = (total, kdvRate, prev) => [{
  key: "single", product_id: "", brand: "", name: prev?.key === "single" ? prev.name : SINGLE_NAME, code: "", unit: "ADET",
  quantity: 1, unit_price: r2((Number(total) || 0) / (1 + (Number(kdvRate) || 0) / 100)), discount_rate: 0,
}];

// Hızlı yuvarlama seçenekleri: sepet tutarı + 1 / 10 / 50 / 100 ₺'ye aşağı yuvarlama
export const roundChips = (base) => {
  const b = r2(base);
  const out = [["Sepet tutarı", b]];
  [1, 10, 50, 100].forEach((s) => {
    const v = Math.floor(b / s) * s;
    if (v > 0 && v < b - 0.004 && !out.some(([, x]) => x === v)) out.push([`${s} ₺'ye yuvarla`, v]);
  });
  return out;
};
